/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Origin } from './';
import {
    OriginFromJSON,
    OriginFromJSONTyped,
    OriginToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProjectTitleWithOrigin
 */
export interface ProjectTitleWithOrigin {
    /**
     * 
     * @type {string}
     * @memberof ProjectTitleWithOrigin
     */
    value: string;
    /**
     * 
     * @type {Origin}
     * @memberof ProjectTitleWithOrigin
     */
    origin: Origin;
}

/**
 * Check if a given object implements the ProjectTitleWithOrigin interface.
 */
export function instanceOfProjectTitleWithOrigin(value: object): value is ProjectTitleWithOrigin {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('origin' in value) || value['origin'] === undefined) return false;
    return true;
}

export function ProjectTitleWithOriginFromJSON(json: any): ProjectTitleWithOrigin {
    return ProjectTitleWithOriginFromJSONTyped(json, false);
}

export function ProjectTitleWithOriginFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectTitleWithOrigin {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'origin': OriginFromJSON(json['origin']),
    };
}

export function ProjectTitleWithOriginToJSON(value?: ProjectTitleWithOrigin | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'value': value['value'],
        'origin': OriginToJSON(value['origin']),
    };
}

